import React from "react";

function NormalInput({
  placeholder,
  onchange,
  value,
  name,
  label,
  mb0 = false,
  type = "text",
  full = false,
  required = false,
  helperText,
  min = 1,
  emptyField = [],
  ...props
}) {
  return (
    <div className={`form-group ${mb0 ? "mb-0" : "mb-3"}`}>
      {label && (
        <label className="form-label" htmlFor="exampleFormControlInput1">
          {label} {required ? <span className="text-danger">*</span> : ""}
        </label>
      )}
      <input
        {...props}
        className={`form-control ${
          emptyField.includes(name) ? "is-invalid" : ""
        }`}
        style={{ width: "100%", backgroundColor: "#0000007a", ...props.style }}
        type={type}
        min={min}
        placeholder={placeholder}
        onChange={onchange}
        name={name}
        value={value}
      />
      {helperText && (
        <p className="text-muted mt-2" style={{ fontSize: 12 }}>
          {helperText}
        </p>
      )}
    </div>
  );
}

export default NormalInput;
